export const INVOKE_ADDIN_COMMAND = 'Action.InvokeAddInCommand';
export const DISPLAY_REPLY_ALL_FORM = 'Action.DisplayReplyAllForm';
export const DISPLAY_APPOINTMENT_FORM = 'Action.DisplayAppointmentForm';
export const DISPLAY_MESSAGE_FORM = 'Action.DisplayMessageForm';
export const START_BOT_CONVERSATION = 'Action.StartBotConversation';
